// Adapted from jobsamuel/venezuela-js (MIT), with updated names and locations.
// https://github.com/jobsamuel/venezuela-js/tree/75503be98b1b75cf8c75465e0ff00bbdec2cd666
/*
Copyright (c) 2018 Jobsamuel Núñez

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/

export const VENEZUELA_LOCATIONS = {
  Amazonas: [
    "La Esmeralda", "Maroa", "Puerto Ayacucho", "San Carlos de Río Negro",
    "San Fernando de Atabapo", "San Juan de Manapiare", "Isla Ratón",
  ],
  Anzoátegui: [
    "Anaco", "Aragua de Barcelona", "Barcelona", "Boca de Uchire", "Cantaura",
    "Clarines", "El Chaparro", "El Pao", "El Tigre", "El Tigrito", "Guanape",
    "Guanta", "Lechería", "Onoto", "Pariaguán", "Píritu", "Puerto La Cruz",
    "Puerto Píritu", "Sabana de Uchire", "San Mateo", "San Pablo", "San Tomé",
    "Santa Ana", "Santa Fe", "Santa Rosa", "Soledad", "Urica", "Valle de Guanape",
  ],
  Apure: [
    "Achaguas", "Biruaca", "Bruzual", "El Amparo", "El Nula", "Elorza",
    "Guasdualito", "Mantecal", "Puerto Páez", "San Fernando de Apure",
    "San Juan de Payara",
  ],
  Aragua: [
    "Barbacoas", "Cagua", "Camatagua", "Choroní", "Colonia Tovar", "El Consejo",
    "La Victoria", "Las Tejerías", "Magdaleno", "Maracay", "Ocumare de la Costa",
    "Palo Negro", "San Casimiro", "San Mateo", "San Sebastián",
    "Santa Cruz de Aragua", "Tocorón", "Turmero", "Villa de Cura", "Zuata",
  ],
  Barinas: [
    "Barinas", "Barinitas", "Barrancas", "Calderas", "Capitanejo",
    "Ciudad Bolivia", "El Cantón", "Las Veguitas", "Libertad de Barinas",
    "Sabaneta", "Santa Bárbara de Barinas", "Socopó",
  ],
  Bolívar: [
    "Caicara del Orinoco", "Canaima", "Ciudad Bolívar", "Ciudad Guayana",
    "Ciudad Piar", "El Callao", "El Dorado", "El Manteco", "El Palmar",
    "El Pao", "Guasipati", "Guri", "La Paragua", "Matanzas", "Puerto Ordaz",
    "San Félix", "Santa Elena de Uairén", "Tumeremo", "Unare", "Upata",
  ],
  Carabobo: [
    "Bejuma", "Belén", "Campo de Carabobo", "Canoabo", "Central Tacarigua",
    "Chirgua", "Ciudad Alianza", "El Palito", "Guacara", "Güigüe",
    "Las Trincheras", "Los Guayos", "Mariara", "Miranda", "Montalbán",
    "Morón", "Naguanagua", "Puerto Cabello", "San Joaquín", "Tocuyito",
    "Urama", "Valencia", "Vigirimita",
  ],
  Cojedes: [
    "Aguirre", "Apartaderos", "Arismendi", "Camuriquito", "El Baúl",
    "El Limón", "El Pao", "El Socorro", "La Aguadita", "Las Vegas",
    "Libertad de Cojedes", "Mapuey", "Piñedo", "Samancito", "San Carlos",
    "Sucre", "Tinaco", "Tinaquillo", "Vallecito",
  ],
  "Delta Amacuro": ["Curiapo", "Pedernales", "Sierra Imataca", "Tucupita"],
  "Distrito Capital": ["Caracas"],
  Falcón: [
    "Adícora", "Boca de Aroa", "Cabure", "Capadare", "Capatárida",
    "Chichiriviche", "Churuguara", "Coro", "Cumarebo", "Dabajuro",
    "Judibana", "La Cruz de Taratara", "La Vela de Coro", "Los Taques",
    "Maparari", "Mene de Mauroa", "Mirimire", "Pedregal", "Píritu",
    "Pueblo Nuevo", "Puerto Cumarebo", "Punta Cardón", "Punto Fijo",
    "San Juan de los Cayos", "San Luis", "Santa Ana", "Santa Cruz de Bucaral",
    "Tocopero", "Tocuyo de la Costa", "Tucacas", "Yaracal",
  ],
  Guárico: [
    "Altagracia de Orituco", "Cabruta", "Calabozo", "Camaguán",
    "Chaguaramas", "El Socorro", "El Sombrero", "Las Mercedes del Llano",
    "Lezama", "Ortiz", "San José de Guaribe", "San Juan de los Morros",
    "San Rafael de Laya", "Santa María de Ipire", "Tucupido",
    "Valle de la Pascua", "Zaraza",
  ],
  "La Guaira": [
    "Caraballeda", "Carayaca", "Catia La Mar", "Chuspa", "La Guaira",
    "La Sabana", "Macuto", "Maiquetía", "Naiguatá",
  ],
  Lara: [
    "Aguada Grande", "Atarigua", "Barquisimeto", "Bobare", "Cabudare",
    "Carora", "Cubiro", "Cují", "Duaca", "El Manzano", "El Tocuyo",
    "Guarico", "Humocaro Alto", "Humocaro Bajo", "La Miel", "Moroturo",
    "Quíbor", "Río Claro", "Sanare", "Santa Inés", "Sarare", "Siquisique",
    "Tintorero",
  ],
  Mérida: [
    "Apartaderos", "Arapuey", "Bailadores", "Canaguá", "Chachopo",
    "Chiguará", "Ejido", "El Vigía", "La Azulita", "La Playa", "Lagunillas",
    "Mérida", "Mesa de Bolívar", "Mucuchíes", "Mucujepe", "Mucurubá",
    "Nueva Bolivia", "Palmarito", "Pueblo Llano", "Santa Cruz de Mora",
    "Santa Elena de Arenales", "Santo Domingo", "Tabay", "Timotes",
    "Torondoy", "Tovar", "Tucaní", "Zea",
  ],
  Miranda: [
    "Aragüita", "Carrizal", "Caucagua", "Chaguaramas", "Charallave",
    "Chirimena", "Cúa", "Cupira", "Curiepe", "El Guapo", "El Jarillo",
    "Filas de Mariche", "Guarenas", "Guatire", "Higuerote", "Los Anaucos",
    "Los Teques", "Ocumare del Tuy", "Panaquire", "Paracotos", "Río Chico",
    "San Antonio de los Altos", "San Diego de los Altos",
    "San Fernando del Guapo", "San Francisco de Yare", "San José de los Altos",
    "San José de Río Chico", "San Pedro de los Altos", "Santa Lucía",
    "Santa Teresa", "Tacarigua de la Laguna", "Tacarigua de Mamporal",
    "Tácata", "Turumo",
  ],
  Monagas: [
    "Aguasay", "Aragua de Maturín", "Barrancas del Orinoco",
    "Caicara de Maturín", "Caripe", "Caripito", "Chaguaramal", "Chaguaramas",
    "El Furrial", "El Tejero", "Jusepín", "La Toscana", "Maturín",
    "Miraflores", "Punta de Mata", "Quiriquire", "San Antonio de Maturín",
    "San Vicente", "Santa Bárbara", "Temblador", "Teresén", "Uracoa",
  ],
  "Nueva Esparta": [
    "Altagracia", "Boca de Pozo", "Boca de Río", "El Espinal",
    "El Valle del Espíritu Santo", "El Yaque", "Juangriego", "La Asunción",
    "La Guardia", "Pampatar", "Porlamar", "Puerto Fermín", "Punta de Piedras",
    "San Francisco de Macanao", "San Juan Bautista", "San Pedro de Coche",
    "Santa Ana de Nueva Esparta", "Villa Rosa",
  ],
  Portuguesa: [
    "Acarigua", "Agua Blanca", "Araure", "Biscucuy", "Boconoíto",
    "Campo Elías", "Chabasquén", "Guanare", "Guanarito", "La Aparición",
    "La Misión", "Mesa de Cavacas", "Ospino", "Papelón", "Payara",
    "Pimpinela", "Píritu", "San Rafael de Onoto", "Santa Rosalía", "Turén",
  ],
  Sucre: [
    "Altos de Sucre", "Araya", "Cariaco", "Carúpano", "Casanay", "Cumaná",
    "Cumanacoa", "El Morro Puerto Santo", "El Pilar", "El Poblado",
    "Guaca", "Güiria", "Irapa", "Manicuare", "Marigüitar", "Río Caribe",
    "San Antonio del Golfo", "San José de Aerocuar", "San Vicente",
    "Santa Fe", "Tunapuy", "Yaguaraparo", "Yoco",
  ],
  Táchira: [
    "Abejales", "Borotá", "Bramón", "Capacho", "Colón", "Coloncito",
    "Cordero", "El Cobre", "El Piñal", "Independencia", "La Fría",
    "La Grita", "La Pedrera", "La Tendida", "Las Delicias", "Las Hernández",
    "Lobatera", "Michelena", "Palmira", "Pregonero", "Queniquea", "Rubio",
    "San Antonio del Táchira", "San Cristóbal", "San José de Bolívar",
    "San Josecito", "San Pedro del Río", "Santa Ana", "Seboruco", "Táriba",
    "Umuquena",
  ],
  Trujillo: [
    "Batatal", "Betijoque", "Boconó", "Carache", "Chejendé", "Cuicas",
    "El Dividive", "El Jagüito", "Escuque", "Isnotú", "Jajó", "La Ceiba",
    "La Concepción", "La Mesa de Esnujaque", "La Puerta", "La Quebrada",
    "Mendoza Fría", "Meseta de Chimpire", "Monay", "Motatán", "Pampán",
    "Pampanito", "Sabana de Mendoza", "San Lázaro", "Santa Ana", "Tostós",
    "Trujillo", "Valera",
  ],
  Yaracuy: [
    "Aroa", "Boraure", "Campo Elías", "Chivacoa", "Cocorote", "Farriar",
    "Guama", "Marín", "Nirgua", "Sabana de Parra", "Salom", "San Felipe",
    "San Pablo", "Urachiche", "Yaritagua", "Yumare",
  ],
  Zulia: [
    "Bachaquero", "Bobures", "Cabimas", "Caja Seca", "Campo Concepción",
    "Campo Mara", "Campo Rojo", "Carrasquero", "Casigua", "Chiquinquirá",
    "Ciudad Ojeda", "El Batey", "El Carmelo", "El Chivo", "El Guayabo",
    "El Mene", "El Venado", "Encontrados", "Gibraltar", "Isla de Toas",
    "La Concepción", "La Paz", "La Sierrita", "Lagunillas", "Las Piedras",
    "Los Cortijos", "Machiques", "Maracaibo", "Mene Grande", "Palmarejo",
    "Paraguaipoa", "Potrerito", "Pueblo Nuevo", "Puertos de Altagracia",
    "Punta Gorda", "Sabaneta de Palma", "San Francisco", "San José de Perijá",
    "San Rafael del Moján", "San Timoteo", "Santa Bárbara del Zulia",
    "Santa Cruz de Mara", "Santa Cruz del Zulia", "Santa Rita", "Sinamaica",
    "Tamare", "Tía Juana", "Villa del Rosario",
  ],
};

const normalize = (value) =>
  value.trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

export const getVenezuelaCities = (state) => {
  const normalizedState = normalize(state);
  const name = normalizedState === "vargas"
    ? "La Guaira"
    : Object.keys(VENEZUELA_LOCATIONS).find(
      (item) => normalize(item) === normalizedState
    );
  return name ? VENEZUELA_LOCATIONS[name] : [];
};

export const getLocationOptions = (options, savedValue = "") => {
  const sorted = [...options].sort((a, b) => a.localeCompare(b, "es"));
  // Keep legacy free-text values visible until the user replaces them.
  return savedValue && !sorted.includes(savedValue)
    ? [savedValue, ...sorted]
    : sorted;
};
